import { render, staticRenderFns } from "./DriverAppDriverRemarksDialog.vue?vue&type=template&id=b22ea6b6&scoped=true"
import script from "./DriverAppDriverRemarksDialog.vue?vue&type=script&lang=js"
export * from "./DriverAppDriverRemarksDialog.vue?vue&type=script&lang=js"
import style0 from "./DriverAppDriverRemarksDialog.vue?vue&type=style&index=0&id=b22ea6b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22ea6b6",
  null
  
)

export default component.exports